import gql from "graphql-tag";

export const SEND_MESSAGE_MUTATION = gql`
  mutation SendChatMessage($input: ChatRequestMessageInput!) {
    sendChatMessage(input: $input)
  }
`;

export const CHAT_SUBSCRIPTION = gql`
  subscription OnChatSubscription {
    chatSubscription {
      refusal
      content
      role {
        name
      }
    }
  }
`;
